import React, { PureComponent, Fragment } from 'react'
import Network from 'react-network'
import Angle from './Angle'
import ShakeSearch from './ShakeSearch'
import CurrentPosition from './CurrentPosition'
import WatchPosition from './WatchPosition'
import NetworkEvents from './NetworkEvents'

class DeviceEvents extends PureComponent {
  render() {
    return (
      <Fragment>
        <Angle />
        <ShakeSearch />
        <CurrentPosition />
        <WatchPosition />
        <Network render={({ online }) => <NetworkEvents online={online} />} />
      </Fragment>
    )
  }
}

export default DeviceEvents



// WEBPACK FOOTER //
// ./src/components/Elements/DeviceEvents/index.jsx